import {v4 as uuidv4} from "uuid"
import {
  EmailThread,
  Profile,
  EmailMessage,
  MessageParticipantType,
} from "@/utils/graphQL/queries/threads/shared"

// Ben Taft's profile
const benTaftProfile: Profile = {
  auth_user_id: "ben-taft-auth-id",
  channel_type: "email",
  channel_handle: "ben@obsidianlabs.co",
  created_at: "2023-01-01T00:00:00Z",
  is_active: true,
  name: "Ben Taft",
  phone_number: "+16505551234",
  company: "Obsidian Labs",
  title: "CEO & Founding Partner",
  email: "ben@obsidianlabs.co",
}

// Other common profiles
const sarahJohnsonProfile: Profile = {
  auth_user_id: "sarah-johnson-auth-id",
  channel_type: "email",
  channel_handle: "sarah@luminaventures.com",
  created_at: "2023-01-02T00:00:00Z",
  is_active: true,
  name: "Sarah Johnson",
  phone_number: "+16505552345",
  company: "Lumina Ventures",
  title: "Managing Partner",
  email: "sarah@luminaventures.com",
}

const alexChengProfile: Profile = {
  auth_user_id: "alex-cheng-auth-id",
  channel_type: "email",
  channel_handle: "alex@quantumai.tech",
  created_at: "2023-01-03T00:00:00Z",
  is_active: true,
  name: "Alex Cheng",
  phone_number: "+16505553456",
  company: "Quantum AI",
  title: "Founder & CEO",
  email: "alex@quantumai.tech",
}

const mikeRodriguezProfile: Profile = {
  auth_user_id: "mike-rodriguez-auth-id",
  channel_type: "email",
  channel_handle: "mike@finregulators.gov",
  created_at: "2023-01-04T00:00:00Z",
  is_active: true,
  name: "Mike Rodriguez",
  phone_number: "+16505554567",
  company: "Financial Regulatory Authority",
  title: "Compliance Officer",
  email: "mike@finregulators.gov",
}

const jenniferLiProfile: Profile = {
  auth_user_id: "jennifer-li-auth-id",
  channel_type: "email",
  channel_handle: "jennifer@quartzapp.co",
  created_at: "2023-01-05T00:00:00Z",
  is_active: true,
  name: "Jennifer Li",
  phone_number: "+16505555678",
  company: "Quartz",
  title: "Head of Engineering",
  email: "jennifer@quartzapp.co",
}

const davidPatelProfile: Profile = {
  auth_user_id: "david-patel-auth-id",
  channel_type: "email",
  channel_handle: "david@skylinecapital.com",
  created_at: "2023-01-06T00:00:00Z",
  is_active: true,
  name: "David Patel",
  phone_number: "+16505556789",
  company: "Skyline Capital",
  title: "Investment Partner",
  email: "david@skylinecapital.com",
}

const rachelKimProfile: Profile = {
  auth_user_id: "rachel-kim-auth-id",
  channel_type: "email",
  channel_handle: "rachel@blockchainrevolution.io",
  created_at: "2023-01-07T00:00:00Z",
  is_active: true,
  name: "Rachel Kim",
  phone_number: "+16505557890",
  company: "Blockchain Revolution",
  title: "Co-founder",
  email: "rachel@blockchainrevolution.io",
}

// More realistic profiles
const tomWilsonProfile: Profile = {
  auth_user_id: "tom-wilson-auth-id",
  channel_type: "email",
  channel_handle: "tom@elevatevc.com",
  created_at: "2023-01-08T00:00:00Z",
  is_active: true,
  name: "Tom Wilson",
  phone_number: "+16505558901",
  company: "Elevate Ventures",
  title: "Partner",
  email: "tom@elevatevc.com",
}

const lisaHuangProfile: Profile = {
  auth_user_id: "lisa-huang-auth-id",
  channel_type: "email",
  channel_handle: "lisa@datascale.ai",
  created_at: "2023-01-09T00:00:00Z",
  is_active: true,
  name: "Lisa Huang",
  phone_number: "+16505559012",
  company: "DataScale AI",
  title: "CEO",
  email: "lisa@datascale.ai",
}

const markJohnsonProfile: Profile = {
  auth_user_id: "mark-johnson-auth-id",
  channel_type: "email",
  channel_handle: "mark@obsidianlabs.co",
  created_at: "2023-01-10T00:00:00Z",
  is_active: true,
  name: "Mark Johnson",
  phone_number: "+16505550123",
  company: "Obsidian Labs",
  title: "COO",
  email: "mark@obsidianlabs.co",
}

const emilyChenProfile: Profile = {
  auth_user_id: "emily-chen-auth-id",
  channel_type: "email",
  channel_handle: "emily@techinvestors.com",
  created_at: "2023-01-11T00:00:00Z",
  is_active: true,
  name: "Emily Chen",
  phone_number: "+16505551234",
  company: "Tech Investors Group",
  title: "Investment Associate",
  email: "emily@techinvestors.com",
}

const jamesBrownProfile: Profile = {
  auth_user_id: "james-brown-auth-id",
  channel_type: "email",
  channel_handle: "james@safepay.io",
  created_at: "2023-01-12T00:00:00Z",
  is_active: true,
  name: "James Brown",
  phone_number: "+16505552345",
  company: "SafePay",
  title: "Founder",
  email: "james@safepay.io",
}

// Create email threads with realistic content
export const emailThreadsStub: EmailThread[] = [
  // Thread 1: Potential Investment Discussion
  {
    thread_uid: uuidv4(),
    created_at: "2023-11-15T14:30:00Z",
    title: "Potential Investment Opportunity - Quantum AI",
    description:
      "Discussion about potential investment in Quantum AI's Series A round",
    last_message_timestamp: "2023-11-17T09:45:00Z",
    profiles: [benTaftProfile, alexChengProfile],
    messages: [
      {
        sent_at: "2023-11-15T14:30:00Z",
        message:
          "Hi Ben,\n\nI hope this email finds you well. I've been following Obsidian Labs' investments in the AI space and I'm impressed with your portfolio companies. \n\nI'm reaching out because Quantum AI is preparing for our Series A round, and I believe there might be a strong alignment between our vision and your investment thesis. We've developed a revolutionary quantum machine learning platform that's showing promising results in financial forecasting and risk assessment applications.\n\nWould you be interested in scheduling a call to discuss this opportunity further? I'd be happy to share our deck and some preliminary data on our technology's performance.\n\nLooking forward to your response.\n\nBest regards,\nAlex Cheng\nFounder & CEO, Quantum AI",
        channel_type: "email",
        provider_handle: "alex@quantumai.tech",
        provider_type: "Outlook",
        profiles: [alexChengProfile],
        attachments: [],
        raw_content: "",
        subject: "Potential Investment Opportunity - Quantum AI",
        sensitivity: 2,
        metadata: {
          recipients: [
            {
              type: MessageParticipantType.recipient,
              email: "ben@obsidianlabs.co",
            },
          ],
          authorMember: {
            name: "Alex Cheng",
            email: "alex@quantumai.tech",
            user_id: "alex-cheng-auth-id",
          },
          destinationMembers: [
            {
              name: "Ben Taft",
              email: "ben@obsidianlabs.co",
              user_id: "ben-taft-auth-id",
            },
          ],
        },
      },
      {
        sent_at: "2023-11-16T10:15:00Z",
        message:
          "Hi Alex,\n\nThanks for reaching out. I've actually been following Quantum AI's progress for some time now - your work in applying quantum computing principles to financial models caught my attention at the last TechCrunch Disrupt.\n\nI'd definitely be interested in learning more about your Series A plans and how Obsidian Labs might fit into your vision. Quantum computing applications in fintech is a space we're actively exploring.\n\nHow does your calendar look next Tuesday or Wednesday afternoon? I could do a call between 2-5pm PT on either day.\n\nLooking forward to our conversation.\n\nBest,\nBen Taft\nCEO & Founding Partner\nObsidian Labs",
        channel_type: "email",
        provider_handle: "ben@obsidianlabs.co",
        provider_type: "Outlook",
        profiles: [benTaftProfile],
        attachments: [],
        raw_content: "",
        subject: "Re: Potential Investment Opportunity - Quantum AI",
        metadata: {
          recipients: [
            {
              type: MessageParticipantType.recipient,
              email: "alex@quantumai.tech",
            },
          ],
          authorMember: {
            name: "Ben Taft",
            email: "ben@obsidianlabs.co",
            user_id: "ben-taft-auth-id",
          },
          destinationMembers: [
            {
              name: "Alex Cheng",
              email: "alex@quantumai.tech",
              user_id: "alex-cheng-auth-id",
            },
          ],
        },
      },
      {
        sent_at: "2023-11-17T09:45:00Z",
        message:
          "Ben,\n\nGreat to hear from you! I'm thrilled that you're familiar with our work. Yes, TechCrunch was a fantastic event for us.\n\nWednesday at 3pm PT works perfectly for me. I'll send over our deck and latest performance metrics today so you can review them before our call.\n\nI'm excited about the prospect of working with Obsidian Labs. Your expertise in both fintech and regulatory compliance would be invaluable as we scale our platform.\n\nLooking forward to our conversation next week!\n\nBest,\nAlex",
        channel_type: "email",
        provider_handle: "alex@quantumai.tech",
        provider_type: "Outlook",
        profiles: [alexChengProfile],
        attachments: [],
        raw_content: "",
        subject: "Re: Potential Investment Opportunity - Quantum AI",
        metadata: {
          recipients: [
            {
              type: MessageParticipantType.recipient,
              email: "ben@obsidianlabs.co",
            },
          ],
          authorMember: {
            name: "Alex Cheng",
            email: "alex@quantumai.tech",
            user_id: "alex-cheng-auth-id",
          },
          destinationMembers: [
            {
              name: "Ben Taft",
              email: "ben@obsidianlabs.co",
              user_id: "ben-taft-auth-id",
            },
          ],
        },
      },
    ],
  },

  // Thread 2: Quartz Product Development
  {
    thread_uid: uuidv4(),
    created_at: "2023-11-12T16:20:00Z",
    title: "Quartz Product Roadmap Discussion",
    description:
      "Internal discussion about Quartz product roadmap and regulatory features",
    last_message_timestamp: "2023-11-14T11:30:00Z",
    profiles: [benTaftProfile, jenniferLiProfile],
    messages: [
      {
        sent_at: "2023-11-12T16:20:00Z",
        message:
          "Hey Jennifer,\n\nAfter today's meeting with the FINRA rep, I think we need to prioritize the new compliance monitoring dashboard. The feedback we got suggests that many financial institutions are struggling with real-time monitoring of communications across multiple channels.\n\nCan we move this up in our Q1 roadmap? I think it could be a significant competitive advantage if we can deliver it before the new regulations take effect in April.\n\nLet me know your thoughts on feasibility and what resources you might need to accelerate this.\n\nThanks,\nBen",
        channel_type: "email",
        provider_handle: "ben@obsidianlabs.co",
        provider_type: "Outlook",
        profiles: [benTaftProfile],
        attachments: [],
        raw_content: "",
        subject: "Quartz Product Roadmap Discussion",
        sensitivity: 3,
        metadata: {
          recipients: [
            {
              type: MessageParticipantType.recipient,
              email: "jennifer@quartzapp.co",
            },
          ],
          authorMember: {
            name: "Ben Taft",
            email: "ben@obsidianlabs.co",
            user_id: "ben-taft-auth-id",
          },
          destinationMembers: [
            {
              name: "Jennifer Li",
              email: "jennifer@quartzapp.co",
              user_id: "jennifer-li-auth-id",
            },
          ],
        },
      },
      {
        sent_at: "2023-11-13T09:15:00Z",
        message:
          "Hi Ben,\n\nI was thinking the same thing after the meeting. The compliance dashboard is definitely a high-value feature that aligns with where the regulations are headed.\n\nAfter reviewing with the team, I think we can pull this forward, but we'd need to make some adjustments:\n\n1. We'll need to shift one backend engineer from the analytics project to this\n2. We might need to simplify the first iteration of the UI to meet the April deadline\n3. We'll need clear specs on exactly which communication channels need to be prioritized\n\nIf you're ok with these trade-offs, we can start the sprint planning next week. Would also be great to get some direct feedback from potential users as we design the initial version.\n\nLet me know if you want to discuss further.\n\nJennifer",
        channel_type: "email",
        provider_handle: "jennifer@quartzapp.co",
        provider_type: "Outlook",
        profiles: [jenniferLiProfile],
        attachments: [],
        raw_content: "",
        subject: "Re: Quartz Product Roadmap Discussion",
        metadata: {
          recipients: [
            {
              type: MessageParticipantType.recipient,
              email: "ben@obsidianlabs.co",
            },
          ],
          authorMember: {
            name: "Jennifer Li",
            email: "jennifer@quartzapp.co",
            user_id: "jennifer-li-auth-id",
          },
          destinationMembers: [
            {
              name: "Ben Taft",
              email: "ben@obsidianlabs.co",
              user_id: "ben-taft-auth-id",
            },
          ],
        },
      },
      {
        sent_at: "2023-11-14T11:30:00Z",
        message:
          "Jennifer,\n\nThose trade-offs make sense to me. Let's prioritize email, Slack, and SMS for the first version since those are explicitly mentioned in the new guidelines.\n\nI've scheduled two customer interviews for next week with compliance officers from JP Morgan and Goldman Sachs. They're both eager to see what we're building and provide feedback. I'll make sure you're included in those calls.\n\nFor the UI simplification, let's focus on the monitoring and alerting features first. The advanced analytics can come in a later update.\n\nThanks for being flexible with the roadmap. I believe this is the right move strategically.\n\nBen",
        channel_type: "email",
        provider_handle: "ben@obsidianlabs.co",
        provider_type: "Outlook",
        profiles: [benTaftProfile],
        attachments: [],
        raw_content: "",
        subject: "Re: Quartz Product Roadmap Discussion",
        metadata: {
          recipients: [
            {
              type: MessageParticipantType.recipient,
              email: "jennifer@quartzapp.co",
            },
          ],
          authorMember: {
            name: "Ben Taft",
            email: "ben@obsidianlabs.co",
            user_id: "ben-taft-auth-id",
          },
          destinationMembers: [
            {
              name: "Jennifer Li",
              email: "jennifer@quartzapp.co",
              user_id: "jennifer-li-auth-id",
            },
          ],
        },
      },
    ],
  },

  // Thread 3: Co-investment Opportunity
  {
    thread_uid: uuidv4(),
    created_at: "2023-11-10T08:45:00Z",
    title: "Co-investment opportunity in BlockchainRevolution",
    description: "Discussion about co-investing in a blockchain startup",
    last_message_timestamp: "2023-11-13T15:20:00Z",
    profiles: [benTaftProfile, sarahJohnsonProfile, davidPatelProfile],
    messages: [
      {
        sent_at: "2023-11-10T08:45:00Z",
        message:
          "Hey Ben and David,\n\nI wanted to reach out about a promising opportunity that came across my desk this week. BlockchainRevolution is raising their seed round, and I think it could be an excellent fit for all of us to co-invest.\n\nThey're building a compliance-focused blockchain solution for financial institutions that checks a lot of boxes for what we've been looking for in the space. The founding team comes from Goldman and has deep expertise in both blockchain and regulatory requirements.\n\nI'm considering leading with $2M, and they're looking to close a $5M round. Would either of you be interested in joining? I can share the deck and intro you to Rachel, the CEO.\n\nHope you're both well!\n\nSarah Johnson\nManaging Partner\nLumina Ventures",
        channel_type: "email",
        provider_handle: "sarah@luminaventures.com",
        provider_type: "Outlook",
        profiles: [sarahJohnsonProfile],
        attachments: [],
        raw_content: "",
        subject: "Co-investment opportunity in BlockchainRevolution",
        sensitivity: 1,
        metadata: {
          recipients: [
            {
              type: MessageParticipantType.recipient,
              email: "ben@obsidianlabs.co",
            },
            {
              type: MessageParticipantType.recipient,
              email: "david@skylinecapital.com",
            },
          ],
          authorMember: {
            name: "Sarah Johnson",
            email: "sarah@luminaventures.com",
            user_id: "sarah-johnson-auth-id",
          },
          destinationMembers: [
            {
              name: "Ben Taft",
              email: "ben@obsidianlabs.co",
              user_id: "ben-taft-auth-id",
            },
            {
              name: "David Patel",
              email: "david@skylinecapital.com",
              user_id: "david-patel-auth-id",
            },
          ],
        },
      },
      {
        sent_at: "2023-11-10T14:30:00Z",
        message:
          "Hi Sarah,\n\nThis sounds interesting! I've been looking to expand our blockchain portfolio, especially solutions focused on institutional adoption. And the Goldman pedigree is always a plus.\n\nI'd love to see the deck and meet Rachel. Given our work with Quartz, I think we could bring valuable insights on the compliance and regulatory side.\n\nWhat's their traction like so far? Any pilot customers or partnerships worth noting?\n\nBen Taft\nCEO & Founding Partner\nObsidian Labs",
        channel_type: "email",
        provider_handle: "ben@obsidianlabs.co",
        provider_type: "Outlook",
        profiles: [benTaftProfile],
        attachments: [],
        raw_content: "",
        subject: "Re: Co-investment opportunity in BlockchainRevolution",
        sensitivity: 3,
        metadata: {
          recipients: [
            {
              type: MessageParticipantType.recipient,
              email: "sarah@luminaventures.com",
            },
            {
              type: MessageParticipantType.recipient,
              email: "david@skylinecapital.com",
            },
          ],
          authorMember: {
            name: "Ben Taft",
            email: "ben@obsidianlabs.co",
            user_id: "ben-taft-auth-id",
          },
          destinationMembers: [
            {
              name: "Sarah Johnson",
              email: "sarah@luminaventures.com",
              user_id: "sarah-johnson-auth-id",
            },
            {
              name: "David Patel",
              email: "david@skylinecapital.com",
              user_id: "david-patel-auth-id",
            },
          ],
        },
      },
      {
        sent_at: "2023-11-11T09:10:00Z",
        message:
          "Morning all,\n\nI'm interested as well. We've been tracking blockchain solutions in the compliance space, and it's been challenging to find teams that understand both the technical and regulatory aspects.\n\nSarah, could you also share any info on their tokenomics model? I'm particularly interested in how they're balancing utility with regulatory compliance.\n\nDavid Patel\nInvestment Partner\nSkyline Capital",
        channel_type: "email",
        provider_handle: "david@skylinecapital.com",
        provider_type: "Outlook",
        profiles: [davidPatelProfile],
        attachments: [],
        raw_content: "",
        subject: "Re: Co-investment opportunity in BlockchainRevolution",
        metadata: {
          recipients: [
            {
              type: MessageParticipantType.recipient,
              email: "ben@obsidianlabs.co",
            },
            {
              type: MessageParticipantType.recipient,
              email: "sarah@luminaventures.com",
            },
          ],
          authorMember: {
            name: "David Patel",
            email: "david@skylinecapital.com",
            user_id: "david-patel-auth-id",
          },
          destinationMembers: [
            {
              name: "Ben Taft",
              email: "ben@obsidianlabs.co",
              user_id: "ben-taft-auth-id",
            },
            {
              name: "Sarah Johnson",
              email: "sarah@luminaventures.com",
              user_id: "sarah-johnson-auth-id",
            },
          ],
        },
      },
      {
        sent_at: "2023-11-13T15:20:00Z",
        message:
          "Great to hear from both of you!\n\nTo answer your questions:\n\nBen - They have two pilot programs running with regional banks (PacWest and First Republic) and are in late-stage discussions with Citi. Early feedback has been extremely positive, particularly around their audit trail capabilities.\n\nDavid - Their approach is interesting - they're not creating a public token. Instead, they've developed a permissioned blockchain specifically for financial institutions where the 'tokens' represent compliance certifications that can be verified across institutions without revealing sensitive data.\n\nI've attached their deck and technical whitepaper. I'll introduce you both to Rachel in separate emails so you can set up calls.\n\nLooks like we could have a strong syndicate here if we all participate. I'm thinking:\n- Lumina: $2M lead\n- Obsidian: $1-1.5M?\n- Skyline: $1-1.5M?\n\nThat would nearly close their round, which gives us strong positioning for future rounds.\n\nLet me know your thoughts!\n\nSarah",
        channel_type: "email",
        provider_handle: "sarah@luminaventures.com",
        provider_type: "Outlook",
        profiles: [sarahJohnsonProfile],
        attachments: [
          {
            filename: "BlockchainRevolution_Deck.pdf",
            content_type: "application/pdf",
            size: 4500000,
          },
          {
            filename: "BlockchainRevolution_Technical_Whitepaper.pdf",
            content_type: "application/pdf",
            size: 2800000,
          },
        ],
        raw_content: "",
        subject: "Re: Co-investment opportunity in BlockchainRevolution",
        metadata: {
          recipients: [
            {
              type: MessageParticipantType.recipient,
              email: "ben@obsidianlabs.co",
            },
            {
              type: MessageParticipantType.recipient,
              email: "david@skylinecapital.com",
            },
          ],
          authorMember: {
            name: "Sarah Johnson",
            email: "sarah@luminaventures.com",
            user_id: "sarah-johnson-auth-id",
          },
          destinationMembers: [
            {
              name: "Ben Taft",
              email: "ben@obsidianlabs.co",
              user_id: "ben-taft-auth-id",
            },
            {
              name: "David Patel",
              email: "david@skylinecapital.com",
              user_id: "david-patel-auth-id",
            },
          ],
        },
      },
    ],
  },

  // Thread 4: Regulatory Inquiry
  {
    thread_uid: uuidv4(),
    created_at: "2023-11-08T10:05:00Z",
    title: "Follow-up on Compliance Requirements",
    description:
      "Discussion with regulatory authority about compliance requirements for Quartz",
    last_message_timestamp: "2023-11-09T16:45:00Z",
    profiles: [benTaftProfile, mikeRodriguezProfile],
    messages: [
      {
        sent_at: "2023-11-08T10:05:00Z",
        message:
          "Dear Mr. Taft,\n\nI'm writing to follow up on our discussion during last month's RegTech symposium regarding the forthcoming changes to electronic communication supervision requirements.\n\nAs mentioned, the Financial Regulatory Authority is planning to implement more stringent oversight of cross-platform communications starting in Q2 2024. Given Quartz's position in the compliance technology space, we believe your team would benefit from early access to our draft guidelines.\n\nI've attached a confidential brief outlining the key changes. We would appreciate Quartz's feedback, especially regarding the technical feasibility of implementing these monitoring requirements across multiple communication channels.\n\nPlease review and share your thoughts by November 20th. I'm available for a call next week if you'd like to discuss in detail.\n\nRegards,\n\nMike Rodriguez\nCompliance Officer\nFinancial Regulatory Authority",
        channel_type: "email",
        provider_handle: "mike@finregulators.gov",
        provider_type: "Outlook",
        profiles: [mikeRodriguezProfile],
        attachments: [
          {
            filename: "Draft_Communication_Monitoring_Guidelines_2024.pdf",
            content_type: "application/pdf",
            size: 3200000,
          },
        ],
        raw_content: "",
        subject: "Follow-up on Compliance Requirements",
        metadata: {
          recipients: [
            {
              type: MessageParticipantType.recipient,
              email: "ben@obsidianlabs.co",
            },
          ],
          authorMember: {
            name: "Mike Rodriguez",
            email: "mike@finregulators.gov",
            user_id: "mike-rodriguez-auth-id",
          },
          destinationMembers: [
            {
              name: "Ben Taft",
              email: "ben@obsidianlabs.co",
              user_id: "ben-taft-auth-id",
            },
          ],
        },
      },
      {
        sent_at: "2023-11-09T16:45:00Z",
        message:
          "Dear Mr. Rodriguez,\n\nThank you for sharing these draft guidelines. I appreciate the opportunity to provide feedback before they're finalized.\n\nAfter an initial review with our technical and compliance teams, we have several observations:\n\n1. The cross-platform correlation requirement (Section 3.2) presents significant technical challenges, particularly for institutions with legacy systems. We'd suggest phasing this in over 12-18 months rather than the proposed 6 months.\n\n2. The real-time monitoring threshold (99.5% uptime) may be difficult to achieve when integrating with third-party platforms that have their own downtime. Perhaps consider a more flexible SLA structure.\n\n3. The AI-based sentiment analysis requirements are innovative but may lead to false positives. We recommend establishing an industry working group to develop best practices for this technology.\n\nI'd welcome the chance to discuss these points in more detail. I'm available for a call next Wednesday (Nov 15) between 1-4pm ET, or Thursday (Nov 16) morning.\n\nAt Quartz, we're already working on solutions that align with many of these guidelines, and I believe our input could help ensure the final regulations balance robust oversight with practical implementation.\n\nBest regards,\n\nBen Taft\nCEO, Quartz\nFounding Partner, Obsidian Labs",
        channel_type: "email",
        provider_handle: "ben@obsidianlabs.co",
        provider_type: "Outlook",
        profiles: [benTaftProfile],
        attachments: [],
        raw_content: "",
        subject: "Re: Follow-up on Compliance Requirements",
        metadata: {
          recipients: [
            {
              type: MessageParticipantType.recipient,
              email: "mike@finregulators.gov",
            },
          ],
          authorMember: {
            name: "Ben Taft",
            email: "ben@obsidianlabs.co",
            user_id: "ben-taft-auth-id",
          },
          destinationMembers: [
            {
              name: "Mike Rodriguez",
              email: "mike@finregulators.gov",
              user_id: "mike-rodriguez-auth-id",
            },
          ],
        },
      },
    ],
  },

  // Thread 5: Blockchain Startup Outreach
  {
    thread_uid: uuidv4(),
    created_at: "2023-11-05T15:35:00Z",
    title: "Introduction and Potential Partnership",
    description: "Initial outreach from blockchain startup founder",
    last_message_timestamp: "2023-11-07T11:20:00Z",
    profiles: [benTaftProfile, rachelKimProfile],
    messages: [
      {
        sent_at: "2023-11-05T15:35:00Z",
        message:
          "Dear Ben,\n\nI hope this email finds you well. My name is Rachel Kim, co-founder of Blockchain Revolution. We're building a regulatory compliance platform on blockchain specifically designed for financial institutions.\n\nI recently read your article in Forbes about the intersection of fintech and regulatory technology and was impressed by your vision. Your experience with Quartz in the compliance space is particularly relevant to what we're building.\n\nWe're currently in the seed stage and preparing to raise our first institutional round. While we've received interest from several investors, I believe Obsidian Labs could be an ideal partner given your focus on fintech and compliance solutions.\n\nWould you be open to a brief conversation to explore potential synergies, either as an investor or strategic partner? I'd be happy to share our deck and demo our current platform.\n\nThank you for your time and consideration.\n\nBest regards,\nRachel Kim\nCo-founder, Blockchain Revolution",
        channel_type: "email",
        provider_handle: "rachel@blockchainrevolution.io",
        provider_type: "Outlook",
        profiles: [rachelKimProfile],
        attachments: [],
        raw_content: "",
        subject: "Introduction and Potential Partnership",
        metadata: {
          recipients: [
            {
              type: MessageParticipantType.recipient,
              email: "ben@obsidianlabs.co",
            },
          ],
          authorMember: {
            name: "Rachel Kim",
            email: "rachel@blockchainrevolution.io",
            user_id: "rachel-kim-auth-id",
          },
          destinationMembers: [
            {
              name: "Ben Taft",
              email: "ben@obsidianlabs.co",
              user_id: "ben-taft-auth-id",
            },
          ],
        },
      },
      {
        sent_at: "2023-11-07T11:20:00Z",
        message:
          "Hi Rachel,\n\nThanks for reaching out. Your timing is interesting - I was just discussing blockchain-based compliance solutions with some fellow investors yesterday.\n\nI'd be interested in learning more about what you're building at Blockchain Revolution. The intersection of blockchain and regulatory compliance is an area we're actively exploring, both through Obsidian's investments and through potential integrations with Quartz.\n\nCould you share your deck with me? After reviewing it, I'd be happy to set up a call if there seems to be a good fit.\n\nBy the way, have you spoken with Sarah Johnson at Lumina Ventures? She's a co-investor in several of our portfolio companies and has been focusing heavily on blockchain solutions for financial services.\n\nLooking forward to learning more.\n\nBest,\nBen",
        channel_type: "email",
        provider_handle: "ben@obsidianlabs.co",
        provider_type: "Outlook",
        profiles: [benTaftProfile],
        attachments: [],
        raw_content: "",
        subject: "Re: Introduction and Potential Partnership",
        metadata: {
          recipients: [
            {
              type: MessageParticipantType.recipient,
              email: "rachel@blockchainrevolution.io",
            },
          ],
          authorMember: {
            name: "Ben Taft",
            email: "ben@obsidianlabs.co",
            user_id: "ben-taft-auth-id",
          },
          destinationMembers: [
            {
              name: "Rachel Kim",
              email: "rachel@blockchainrevolution.io",
              user_id: "rachel-kim-auth-id",
            },
          ],
        },
      },
    ],
  },
]

// Function to get threads grouped by month
export const getStubThreadsByMonth = () => {
  const monthThreads = new Map<string, EmailThread[]>()

  emailThreadsStub.forEach((thread) => {
    // Use the last message timestamp to determine the month
    const dateObj = new Date(thread.last_message_timestamp)
    const monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ]
    const monthYear = `${monthNames[dateObj.getMonth()]} ${dateObj.getFullYear()}`

    if (!monthThreads.has(monthYear)) {
      monthThreads.set(monthYear, [])
    }

    monthThreads.get(monthYear)?.push(thread)
  })

  // Sort threads within each month by last message timestamp (newest first)
  monthThreads.forEach((threads) => {
    threads.sort((a, b) => {
      return (
        new Date(b.last_message_timestamp).getTime() -
        new Date(a.last_message_timestamp).getTime()
      )
    })
  })

  return monthThreads
}

// Search threads by text
export const searchStubThreads = (searchTerm: string) => {
  if (!searchTerm) return []

  const lowercaseSearch = searchTerm.toLowerCase()

  return emailThreadsStub.filter((thread) => {
    // Search in thread metadata
    if (thread.title?.toLowerCase().includes(lowercaseSearch)) return true
    if (thread.description?.toLowerCase().includes(lowercaseSearch)) return true

    // Search in profiles (participants)
    const hasMatchingProfile = thread.profiles.some(
      (profile) =>
        profile.name.toLowerCase().includes(lowercaseSearch) ||
        profile.email.toLowerCase().includes(lowercaseSearch) ||
        profile.company?.toLowerCase().includes(lowercaseSearch) ||
        profile.title?.toLowerCase().includes(lowercaseSearch)
    )

    if (hasMatchingProfile) return true

    // Search in message content
    const hasMatchingMessage = thread.messages.some(
      (message) =>
        message.message.toLowerCase().includes(lowercaseSearch) ||
        message.subject.toLowerCase().includes(lowercaseSearch)
    )

    return hasMatchingMessage
  })
}

// Add new threads to the end of the emailThreadsStub array

// Add these new thread objects to the emailThreadsStub array
export const additionalThreads: EmailThread[] = [
  // Thread 6: Quick scheduling exchange
  {
    thread_uid: uuidv4(),
    created_at: "2023-11-02T09:15:00Z",
    title: "Coffee next week?",
    description: "Quick scheduling exchange",
    last_message_timestamp: "2023-11-02T15:30:00Z",
    profiles: [benTaftProfile, tomWilsonProfile],
    messages: [
      {
        sent_at: "2023-11-02T09:15:00Z",
        message:
          "Hey Ben, free for coffee next Tuesday? Have some interesting deals to discuss.",
        channel_type: "email",
        provider_handle: "tom@elevatevc.com",
        provider_type: "Outlook",
        profiles: [tomWilsonProfile],
        attachments: [],
        raw_content: "",
        subject: "Coffee next week?",
        metadata: {
          recipients: [
            {
              type: MessageParticipantType.recipient,
              email: "ben@obsidianlabs.co",
            },
          ],
          authorMember: {
            name: "Tom Wilson",
            email: "tom@elevatevc.com",
            user_id: "tom-wilson-auth-id",
          },
          destinationMembers: [
            {
              name: "Ben Taft",
              email: "ben@obsidianlabs.co",
              user_id: "ben-taft-auth-id",
            },
          ],
        },
      },
      {
        sent_at: "2023-11-02T11:20:00Z",
        message: "Morning works. Blue Bottle at 10?",
        channel_type: "email",
        provider_handle: "ben@obsidianlabs.co",
        provider_type: "Outlook",
        profiles: [benTaftProfile],
        attachments: [],
        raw_content: "",
        subject: "Re: Coffee next week?",
        metadata: {
          recipients: [
            {
              type: MessageParticipantType.recipient,
              email: "tom@elevatevc.com",
            },
          ],
          authorMember: {
            name: "Ben Taft",
            email: "ben@obsidianlabs.co",
            user_id: "ben-taft-auth-id",
          },
          destinationMembers: [
            {
              name: "Tom Wilson",
              email: "tom@elevatevc.com",
              user_id: "tom-wilson-auth-id",
            },
          ],
        },
      },
      {
        sent_at: "2023-11-02T15:30:00Z",
        message: "Perfect, see you then!",
        channel_type: "email",
        provider_handle: "tom@elevatevc.com",
        provider_type: "Outlook",
        profiles: [tomWilsonProfile],
        attachments: [],
        raw_content: "",
        subject: "Re: Coffee next week?",
        metadata: {
          recipients: [
            {
              type: MessageParticipantType.recipient,
              email: "ben@obsidianlabs.co",
            },
          ],
          authorMember: {
            name: "Tom Wilson",
            email: "tom@elevatevc.com",
            user_id: "tom-wilson-auth-id",
          },
          destinationMembers: [
            {
              name: "Ben Taft",
              email: "ben@obsidianlabs.co",
              user_id: "ben-taft-auth-id",
            },
          ],
        },
      },
    ],
  },

  // Thread 7: Follow-up from pitch meeting
  {
    thread_uid: uuidv4(),
    created_at: "2023-10-28T16:45:00Z",
    title: "Thanks for the meeting - DataScale AI",
    description: "Follow-up from pitch meeting with AI startup",
    last_message_timestamp: "2023-10-31T09:10:00Z",
    profiles: [benTaftProfile, lisaHuangProfile],
    messages: [
      {
        sent_at: "2023-10-28T16:45:00Z",
        message:
          "Hi Ben,\n\nThanks for taking the time to meet with me yesterday. I really appreciated your insights on our go-to-market strategy.\n\nAs promised, I've attached our updated financial projections and customer acquisition plan. We've incorporated the suggestions you made about focusing on the financial services vertical first.\n\nLet me know if you have any questions.\n\nBest,\nLisa",
        channel_type: "email",
        provider_handle: "lisa@datascale.ai",
        provider_type: "Outlook",
        profiles: [lisaHuangProfile],
        attachments: [
          {
            filename: "DataScale_Financials_Oct2023.pdf",
            content_type: "application/pdf",
            size: 2100000,
          },
          {
            filename: "DataScale_CustomerAcquisition.pdf",
            content_type: "application/pdf",
            size: 1800000,
          },
        ],
        raw_content: "",
        subject: "Thanks for the meeting - DataScale AI",
        metadata: {
          recipients: [
            {
              type: MessageParticipantType.recipient,
              email: "ben@obsidianlabs.co",
            },
          ],
          authorMember: {
            name: "Lisa Huang",
            email: "lisa@datascale.ai",
            user_id: "lisa-huang-auth-id",
          },
          destinationMembers: [
            {
              name: "Ben Taft",
              email: "ben@obsidianlabs.co",
              user_id: "ben-taft-auth-id",
            },
          ],
        },
      },
      {
        sent_at: "2023-10-31T09:10:00Z",
        message:
          "Lisa,\n\nThanks for following up. I've reviewed the materials and I'm impressed with the adjustments you've made.\n\nI'd like to introduce you to our investment committee. Are you free next Thursday afternoon for a 45-minute call?\n\nBen",
        channel_type: "email",
        provider_handle: "ben@obsidianlabs.co",
        provider_type: "Outlook",
        profiles: [benTaftProfile],
        attachments: [],
        raw_content: "",
        subject: "Re: Thanks for the meeting - DataScale AI",
        metadata: {
          recipients: [
            {
              type: MessageParticipantType.recipient,
              email: "lisa@datascale.ai",
            },
          ],
          authorMember: {
            name: "Ben Taft",
            email: "ben@obsidianlabs.co",
            user_id: "ben-taft-auth-id",
          },
          destinationMembers: [
            {
              name: "Lisa Huang",
              email: "lisa@datascale.ai",
              user_id: "lisa-huang-auth-id",
            },
          ],
        },
      },
    ],
  },

  // Thread 8: Internal team discussion
  {
    thread_uid: uuidv4(),
    created_at: "2023-10-25T08:30:00Z",
    title: "Q4 Investment Strategy",
    description: "Internal team discussion about investment focus",
    last_message_timestamp: "2023-10-26T14:15:00Z",
    profiles: [benTaftProfile, markJohnsonProfile, emilyChenProfile],
    messages: [
      {
        sent_at: "2023-10-25T08:30:00Z",
        message:
          "Team,\n\nAs we head into Q4, I want to refine our investment focus. Given market conditions, I suggest we prioritize:\n\n1. Compliance tech (especially AI-driven solutions)\n2. Embedded finance infrastructure\n3. Climate fintech\n\nLet's discuss at tomorrow's investment committee.\n\nBen",
        channel_type: "email",
        provider_handle: "ben@obsidianlabs.co",
        provider_type: "Outlook",
        profiles: [benTaftProfile],
        attachments: [],
        raw_content: "",
        subject: "Q4 Investment Strategy",
        metadata: {
          recipients: [
            {
              type: MessageParticipantType.recipient,
              email: "mark@obsidianlabs.co",
            },
            {
              type: MessageParticipantType.recipient,
              email: "emily@techinvestors.com",
            },
          ],
          authorMember: {
            name: "Ben Taft",
            email: "ben@obsidianlabs.co",
            user_id: "ben-taft-auth-id",
          },
          destinationMembers: [
            {
              name: "Mark Johnson",
              email: "mark@obsidianlabs.co",
              user_id: "mark-johnson-auth-id",
            },
            {
              name: "Emily Chen",
              email: "emily@techinvestors.com",
              user_id: "emily-chen-auth-id",
            },
          ],
        },
      },
      {
        sent_at: "2023-10-25T09:45:00Z",
        message:
          "Makes sense. I've been seeing a lot of deal flow in compliance tech lately. Will prepare a summary of recent pitches in this space for tomorrow.",
        channel_type: "email",
        provider_handle: "emily@techinvestors.com",
        provider_type: "Outlook",
        profiles: [emilyChenProfile],
        attachments: [],
        raw_content: "",
        subject: "Re: Q4 Investment Strategy",
        metadata: {
          recipients: [
            {
              type: MessageParticipantType.recipient,
              email: "ben@obsidianlabs.co",
            },
            {
              type: MessageParticipantType.recipient,
              email: "mark@obsidianlabs.co",
            },
          ],
          authorMember: {
            name: "Emily Chen",
            email: "emily@techinvestors.com",
            user_id: "emily-chen-auth-id",
          },
          destinationMembers: [
            {
              name: "Ben Taft",
              email: "ben@obsidianlabs.co",
              user_id: "ben-taft-auth-id",
            },
            {
              name: "Mark Johnson",
              email: "mark@obsidianlabs.co",
              user_id: "mark-johnson-auth-id",
            },
          ],
        },
      },
      {
        sent_at: "2023-10-26T14:15:00Z",
        message: "Just a reminder, meeting in 15 min. Bringing donuts.",
        channel_type: "email",
        provider_handle: "mark@obsidianlabs.co",
        provider_type: "Outlook",
        profiles: [markJohnsonProfile],
        attachments: [],
        raw_content: "",
        subject: "Re: Q4 Investment Strategy",
        metadata: {
          recipients: [
            {
              type: MessageParticipantType.recipient,
              email: "ben@obsidianlabs.co",
            },
            {
              type: MessageParticipantType.recipient,
              email: "emily@techinvestors.com",
            },
          ],
          authorMember: {
            name: "Mark Johnson",
            email: "mark@obsidianlabs.co",
            user_id: "mark-johnson-auth-id",
          },
          destinationMembers: [
            {
              name: "Ben Taft",
              email: "ben@obsidianlabs.co",
              user_id: "ben-taft-auth-id",
            },
            {
              name: "Emily Chen",
              email: "emily@techinvestors.com",
              user_id: "emily-chen-auth-id",
            },
          ],
        },
      },
    ],
  },

  // Thread 9: Portfolio company update
  {
    thread_uid: uuidv4(),
    created_at: "2023-10-20T11:05:00Z",
    title: "SafePay - Monthly Update",
    description: "Update from portfolio company",
    last_message_timestamp: "2023-10-20T16:30:00Z",
    profiles: [benTaftProfile, jamesBrownProfile],
    messages: [
      {
        sent_at: "2023-10-20T11:05:00Z",
        message:
          "Ben,\n\nHere's our October update:\n\n- MRR: $420K (+18% MoM)\n- Retention: 94%\n- New enterprise clients: 3 (including Chase)\n- Cash runway: 16 months\n\nWe're still facing challenges with the payment processor integration. Mind if I grab 30 mins next week to discuss?\n\nJames",
        channel_type: "email",
        provider_handle: "james@safepay.io",
        provider_type: "Outlook",
        profiles: [jamesBrownProfile],
        attachments: [
          {
            filename: "SafePay_Oct2023_Report.pdf",
            content_type: "application/pdf",
            size: 3200000,
          },
        ],
        raw_content: "",
        subject: "SafePay - Monthly Update",
        metadata: {
          recipients: [
            {
              type: MessageParticipantType.recipient,
              email: "ben@obsidianlabs.co",
            },
          ],
          authorMember: {
            name: "James Brown",
            email: "james@safepay.io",
            user_id: "james-brown-auth-id",
          },
          destinationMembers: [
            {
              name: "Ben Taft",
              email: "ben@obsidianlabs.co",
              user_id: "ben-taft-auth-id",
            },
          ],
        },
      },
      {
        sent_at: "2023-10-20T16:30:00Z",
        message:
          "Great progress on MRR. Let's talk Monday at 2pm. I'll connect you with our payments specialist as well.",
        channel_type: "email",
        provider_handle: "ben@obsidianlabs.co",
        provider_type: "Outlook",
        profiles: [benTaftProfile],
        attachments: [],
        raw_content: "",
        subject: "Re: SafePay - Monthly Update",
        metadata: {
          recipients: [
            {
              type: MessageParticipantType.recipient,
              email: "james@safepay.io",
            },
          ],
          authorMember: {
            name: "Ben Taft",
            email: "ben@obsidianlabs.co",
            user_id: "ben-taft-auth-id",
          },
          destinationMembers: [
            {
              name: "James Brown",
              email: "james@safepay.io",
              user_id: "james-brown-auth-id",
            },
          ],
        },
      },
    ],
  },

  // Thread 10: Quick investor intro
  {
    thread_uid: uuidv4(),
    created_at: "2023-10-15T07:40:00Z",
    title: "Intro: Ben <> Lisa",
    description: "Introduction to potential investor",
    last_message_timestamp: "2023-10-15T13:25:00Z",
    profiles: [benTaftProfile, tomWilsonProfile, lisaHuangProfile],
    messages: [
      {
        sent_at: "2023-10-15T07:40:00Z",
        message:
          "Ben, Lisa,\n\nI'd like to connect you two. \n\nBen - Lisa's team at DataScale is building amazing AI tools for financial compliance. Right up your alley.\n\nLisa - Ben leads Obsidian Labs and has deep expertise in fintech compliance through his work with Quartz.\n\nI'll let you two take it from here.\n\nBest,\nTom",
        channel_type: "email",
        provider_handle: "tom@elevatevc.com",
        provider_type: "Outlook",
        profiles: [tomWilsonProfile],
        attachments: [],
        raw_content: "",
        subject: "Intro: Ben <> Lisa",
        metadata: {
          recipients: [
            {
              type: MessageParticipantType.recipient,
              email: "ben@obsidianlabs.co",
            },
            {
              type: MessageParticipantType.recipient,
              email: "lisa@datascale.ai",
            },
          ],
          authorMember: {
            name: "Tom Wilson",
            email: "tom@elevatevc.com",
            user_id: "tom-wilson-auth-id",
          },
          destinationMembers: [
            {
              name: "Ben Taft",
              email: "ben@obsidianlabs.co",
              user_id: "ben-taft-auth-id",
            },
            {
              name: "Lisa Huang",
              email: "lisa@datascale.ai",
              user_id: "lisa-huang-auth-id",
            },
          ],
        },
      },
      {
        sent_at: "2023-10-15T08:15:00Z",
        message:
          "Thanks for the intro, Tom! (moving to BCC)\n\nLisa, great to connect. I'd love to learn more about what you're building at DataScale. Free for a coffee next week?",
        channel_type: "email",
        provider_handle: "ben@obsidianlabs.co",
        provider_type: "Outlook",
        profiles: [benTaftProfile],
        attachments: [],
        raw_content: "",
        subject: "Re: Intro: Ben <> Lisa",
        metadata: {
          recipients: [
            {
              type: MessageParticipantType.recipient,
              email: "lisa@datascale.ai",
            },
            {
              type: MessageParticipantType.bcc,
              email: "tom@elevatevc.com",
            },
          ],
          authorMember: {
            name: "Ben Taft",
            email: "ben@obsidianlabs.co",
            user_id: "ben-taft-auth-id",
          },
          destinationMembers: [
            {
              name: "Lisa Huang",
              email: "lisa@datascale.ai",
              user_id: "lisa-huang-auth-id",
            },
          ],
        },
      },
      {
        sent_at: "2023-10-15T13:25:00Z",
        message:
          "Thanks Tom and hi Ben!\n\nAbsolutely, I'd be glad to meet. How about Wednesday at 10am at Verve Coffee on Mission?",
        channel_type: "email",
        provider_handle: "lisa@datascale.ai",
        provider_type: "Outlook",
        profiles: [lisaHuangProfile],
        attachments: [],
        raw_content: "",
        subject: "Re: Intro: Ben <> Lisa",
        metadata: {
          recipients: [
            {
              type: MessageParticipantType.recipient,
              email: "ben@obsidianlabs.co",
            },
          ],
          authorMember: {
            name: "Lisa Huang",
            email: "lisa@datascale.ai",
            user_id: "lisa-huang-auth-id",
          },
          destinationMembers: [
            {
              name: "Ben Taft",
              email: "ben@obsidianlabs.co",
              user_id: "ben-taft-auth-id",
            },
          ],
        },
      },
    ],
  },
]

// Update the emailThreadsStub array to include the new threads
emailThreadsStub.push(...additionalThreads)
